import { render } from "./alertAdvertising.vue?vue&type=template&id=6ef4aecb&scoped=true"
import script from "./alertAdvertising.vue?vue&type=script&lang=js"
export * from "./alertAdvertising.vue?vue&type=script&lang=js"

import "./alertAdvertising.vue?vue&type=style&index=0&id=6ef4aecb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef4aecb"],['__file',"src/views/wap/alertAdvertising.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ef4aecb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ef4aecb', __exports__)) {
    console.log('reload')
    api.reload('6ef4aecb', __exports__)
  }
  
  module.hot.accept("./alertAdvertising.vue?vue&type=template&id=6ef4aecb&scoped=true", () => {
    console.log('re-render')
    api.rerender('6ef4aecb', render)
  })

}


export default __exports__